let videos = document.querySelectorAll('.button-play');

videos.forEach(function (el) {
    el.addEventListener('click', function () {
        this.parentElement.classList.add('play');
        this.nextElementSibling.play();
    });
});

let videoElements = document.querySelectorAll('[data-video]');
videoElements.forEach(function (element) {
    element.addEventListener('click', function () {
        let parentElement = this.parentElement;
        let videoProvider = this.getAttribute('data-video-provider');
        let videoId = this.getAttribute('data-video-id');

        switch (videoProvider) {
            case 'youtube':
                this.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId +
                    '?rel=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                parentElement.classList.add('play');
                break;
            case 'vimeo':
                this.innerHTML = '<iframe src="https://player.vimeo.com/video/' + videoId +
                    '?autoplay=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
                let picture = parentElement.querySelector('picture');
                parentElement.classList.add('play');
                picture.classList.add('invisible');
                break;
        }
    });
});
